export const SOFTWARE_RENDERER_PATTERNS = [
  'swiftshader',
  'llvmpipe',
  'software rasterizer',
  'mesa offscreen',
  'mesa software',
  'microsoft basic render',
  'angle (software)',
] as const;

export interface RendererInfo {
  isSoftware: boolean;
  renderer: string;
}

/** 读取 GPU renderer 并判断是否为软件渲染 */
export function detectSoftwareRenderer(): RendererInfo {
  try {
    if (typeof document === 'undefined') {
      return { isSoftware: true, renderer: 'no-document' };
    }

    const canvas = document.createElement('canvas');
    const gl = (
      canvas.getContext('webgl2')
      || canvas.getContext('webgl')
      || canvas.getContext('experimental-webgl')
    ) as WebGLRenderingContext | WebGL2RenderingContext | null;

    if (!gl) {
      return { isSoftware: true, renderer: 'no-webgl' };
    }

    let renderer = '';
    const ext = gl.getExtension('WEBGL_debug_renderer_info');
    if (ext) {
      renderer = String(gl.getParameter(ext.UNMASKED_RENDERER_WEBGL) || '').toLowerCase();
    } else {
      renderer = String(gl.getParameter(gl.RENDERER) || '').toLowerCase();
    }

    const loseCtx = gl.getExtension('WEBGL_lose_context');
    loseCtx?.loseContext();

    const isSoftware = SOFTWARE_RENDERER_PATTERNS.some((pattern) => renderer.includes(pattern));
    return { isSoftware, renderer };
  } catch {
    return { isSoftware: false, renderer: 'unknown' };
  }
}

/** Windows 7 环境判定 */
export function isLegacyWindows(): boolean {
  return typeof navigator !== 'undefined' && /Windows NT 6\.1/.test(navigator.userAgent);
}
